<template>
  <b-container fluid>
    <div class="content-card">
      <page-header title="Análisis por módulos" @back="volverAtras" />

      <b-row>
        <b-col md="4">
          <b-form-group label="Tarifa">
            <b-form-select v-model="tarifaId" :options="maestros.tarifas" @input="actualizarDatos" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Plan">
            <b-form-select v-model="planId" :options="maestros.planes" @input="actualizarDatos" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Estado">
            <b-form-select v-model="estado" :options="maestros.estados" @input="actualizarDatos" />
          </b-form-group>
        </b-col>
      </b-row>

      <FiltrosOfertas @filtrar="filtrosCambiados" v-if="planId && tarifaId" />
      <TablaAnalisisPorModulos :items="items" v-if="planId && tarifaId" />
      <GraficaModulos :items="items.slice(0, 25)" v-if="planId && tarifaId" />
      <b-alert show variant="info" v-else> Selecciona una tarifa y un plan para ver el análisis por módulos. </b-alert>
    </div>
  </b-container>
</template>

<script>
import FiltrosOfertas from "@/views/ofertas/Listar/FiltrosOfertas.vue";
import { useFiltrosOfertaFormStore } from "@/stores/FiltrosOfertaForm.js";
import { tablaAnalisisPorModulos } from "@/services/analisisModulos.js";
import TablaAnalisisPorModulos from "./TablaAnalisisPorModulos.vue";
import GraficaModulos from "./GraficaModulos.vue";
import { mapState } from "pinia";

export default {
  components: {
    FiltrosOfertas,
    TablaAnalisisPorModulos,
    GraficaModulos,
  },
  computed: {
    ...mapState(useFiltrosOfertaFormStore, ["maestros"]),
  },
  data() {
    return {
      planId: null,
      tarifaId: null,
      estado: null,
      items: [],
    };
  },
  methods: {
    volverAtras() {
      this.$router.push("/ofertas");
    },
    async actualizarDatos() {
      if (this.planId && this.tarifaId) {
        const filtrosOfertaFormStore = useFiltrosOfertaFormStore();
        const filtros = filtrosOfertaFormStore.filtrosAplicables;
        filtros.tarifaId = [this.tarifaId];
        filtros.planes = [this.planId];
        if (this.estado) {
          filtros.estados = [this.estado];
        }
        this.items = await tablaAnalisisPorModulos(filtros);
      }
    },
    filtrosCambiados() {
      this.actualizarDatos();
    },
  },
  mounted() {
    const filtrosOfertaFormStore = useFiltrosOfertaFormStore();
    filtrosOfertaFormStore.cargarMaestros();
  },
};
</script>
